import {
  Home,
  Box,
  Add,
  Category,
  Document,
  User,
  Shop,
  Profile2User,
  ProfileAdd,
  Note,
  Archive,
} from "iconsax-reactjs";

export const vendorMenue = [
  {
    screenId: 1,
    arTitle: "الصحفة الرئيسية",
    title: "Home",
    route: "vendor",
    icon: <Home variant="Bulk" />,
  },
  {
    screenId: 2,
    arTitle: "منتجات",
    title: "Products",
    route: "products",
    icon: <Box variant="Bulk" />,
  },
  {
    screenId: 3,
    arTitle: "إضافة منتج",
    title: "Add Product",
    route: "product-info",
    icon: <Add variant="Bulk" />,
  },
  {
    screenId: 4,
    arTitle: "الأصناف",
    title: "Categories",
    route: "categories",
    icon: <Category variant="Bulk" />,
  },
  {
    screenId: 5,
    arTitle: "الطلبات",
    title: "Orders",
    route: "orders",
    icon: <Document variant="Bulk" />,
  },
  {
    screenId: 6,
    arTitle: "الفواتير",
    title: "Invoices",
    route: "invoices",
    icon: <Note variant="Bulk" />,
  },
  {
    screenId: 7,
    arTitle: "قائمة المستخدمين",
    title: "Users",
    route: "users",
    icon: <User variant="Bulk" />,
  },
];

export const adminMenue = [
  {
    screenId: 13,
    arTitle: "الصفحة الرئيسية",
    title: "Home",
    route: "admin",
    icon: <Home variant="Bulk" />,
  },
  {
    screenId: 14,
    arTitle: "قائمة البائعين",
    title: "Vendors",
    route: "vendors",
    icon: <Shop variant="Bulk" />,
  },
  {
    screenId: 15,
    arTitle: "الإعلانات",
    title: "Advertisements",
    route: "advertisements",
    icon: <Archive variant="Bulk" />,
  },
  {
    screenId: 16,
    arTitle: "إضافة بائع",
    title: "Add Vendor",
    route: "vendor-info",
    icon: <ProfileAdd variant="Bulk" />,
  },
  // {
  //   screenId: 17,
  //   arTitle: "الطلبات المعلقة",
  //   title: "Pending Orders",
  //   route: "orders/pending",
  //   icon: <Document variant="Bulk" />,
  // },
  {
    screenId: 17,
    arTitle: "تقارير الطلبات",
    title: "Orders Reports",
    route: "customers/orders",
    icon: <Archive variant="Bulk" />,
  },
  {
    screenId: 7,
    arTitle: "قائمة مديري النظام",
    title: "Admin Users",
    route: "admins/users",
    icon: <Profile2User variant="Bulk" />,
  },
  {
    screenId: 8,
    arTitle: "قائمة الزبائن",
    title: "Customers",
    route: "admins/customers",
    icon: <Profile2User variant="Bulk" />,
  },
];
